var path = jQuery(location).attr('pathname');

if(path !== '/resetpass/') {
  jQuery(document).foundation();
}
